import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import { INDUSTRY } from 'meinian-package/src/component/enum'
import { getIndustry } from '../util'

const convert = (result, gender) => {
  if (getIndustry(gender) === INDUSTRY.SHOES) {
    return [...result.find(m => m.name === '推荐').children.map(m => ({ label: m.name, value: m.name, node: 1 })), { label: '其他', value: '其他', node: 1 }]
  }
  const all = []
  result.forEach((item) => {
    let parent = null
    parent = { label: item.name, value: item.name, node: 1 }
    let children = null
    if (item.children && item.children.length) {
      children = item.children.map(son => ({
        label: son.name,
        value: son.name,
        parent,
        node: 2
      }))
      parent.children = children
    }
    all.push(parent)
  })
  return all
}
export default (props) => {
  const { gender, ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchRunways()
  }, [gender])
  const fetchRunways = async () => {
    try {
      const res = JSON.parse(sessionStorage.getItem('meinianFilters')).find(f => f.itemName === '秀场')?.itemTreeValue.children
      setOptions(convert(res, gender))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select.Tile {...otherProps} data={options} placeholder="不限" />
}
